<mat-dialog-content
  class="!p-0 !h-full flex items-stretch mat-dialog-content-full-height"
>
  <div class="flex w-full">
    <div class="border-r !h-full">
      <div class="text-center border-b p-2">
        <span>Settings</span>
      </div>
      <settings-menu (menuItemClicked)="state = $event"></settings-menu>
    </div>
    <div class="w-full !h-full">
      <div class="text-center border-b capitalize p-2">
        {{ getStateTitle() }}
      </div>
      <div *ngIf="state === 'preferences'">
        <settings-for-preferences></settings-for-preferences>
      </div>

      <div *ngIf="state === 'prefund_pro'">
        <settings-for-prefund-pro></settings-for-prefund-pro>
      </div>

      <div *ngIf="state === 'feature_library'">
        <settings-for-extra-features></settings-for-extra-features>
      </div>

      <!-- Account -->
      <div *ngIf="state === 'account'" class="mb-4">
        <settings-for-account
          (onOpenLoginRequested)="login()"
        ></settings-for-account>
      </div>

      <!-- Advanced -->
      <div class="mb-4" *ngIf="state === 'advanced'">
        <settings-for-advanced></settings-for-advanced>
      </div>

      <!-- About -->
      <div class="mb-4 pt-4" *ngIf="state === 'about'">
        <settings-for-about class="h-full block"></settings-for-about>
      </div>
    </div>
  </div>
</mat-dialog-content>
